// A stock's corporate actions (NSE: splits, bonuses, dividends, rights), as the API gives them.
export interface CorpAction { symbol: string; exDate: string; subject: string; kind: string; rupeesPerShare?: number }

/** A corporate action as a short chart label ("Split ₹10→₹2", "Bonus 1:1", "Div ₹12"). */
export function actionLabel(a: CorpAction): string | null {
  if (a.kind === 'split') { const m = a.subject.match(/from\s*r[se]\.?\s*(\d+(?:\.\d+)?)\D+?to\s*r[se]\.?\s*(\d+(?:\.\d+)?)/i); return m ? `Split ₹${m[1]}→₹${m[2]}` : 'Split'; }
  if (a.kind === 'bonus') { const m = a.subject.match(/(\d+)\s*:\s*(\d+)/); return m ? `Bonus ${m[1]}:${m[2]}` : 'Bonus'; }
  if (a.kind === 'dividend') return a.rupeesPerShare ? `Div ₹${a.rupeesPerShare}` : 'Dividend';
  if (a.kind === 'rights') return 'Rights';
  if (a.kind === 'demerger') return 'Demerger';
  if (a.kind === 'buyback') return 'Buyback';
  return null;
}
